exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__content___1qVQt{display:grid;gap:1rem}.index-module__content___1qVQt form{margin-top:1.5em}.index-module__content___1qVQt .index-module__text___3YxoS{margin-bottom:1.5em;font-size:18px}.index-module__content___1qVQt h2{font-weight:400;margin-bottom:.75em}.index-module__content___1qVQt .index-module__agreeBox___1ZqIx{display:grid;grid-template-columns:auto auto;gap:1em;justify-content:start;margin:1em 0 2em;cursor:pointer}.index-module__content___1qVQt .index-module__agreeBox___1ZqIx p{font-size:18px}.index-module__content___1qVQt .index-module__error___1FAHK{padding:1em;background-color:#f1f0ea;color:#707070;border-radius:5px}", ""]);

// exports
exports.locals = {
	"content": "index-module__content___1qVQt",
	"text": "index-module__text___3YxoS",
	"agreeBox": "index-module__agreeBox___1ZqIx",
	"error": "index-module__error___1FAHK"
};